import React from 'react'
import { useTranslation } from 'react-i18next'
import { ListPagePill, PRIORITY_PILL } from './ListPageCells'
import './ListPageTable.css'

interface TagProps {
  priority: number
}

const TagPriority: React.FC<TagProps> = ({ priority }) => {
  const { t } = useTranslation()
  const style = PRIORITY_PILL[priority] ?? PRIORITY_PILL[4]

  return (
    <ListPagePill
      label={t(`priority.${priority}`, {
        defaultValue: style.label,
      })}
      bg={style.bg}
      color={style.color}
      size="sm"
    />
  )
}

export default TagPriority
